<script>
	import { authStoreSignUp } from '../stores/auth-store.js'

	import { onMount } from 'svelte'

	let isInvitation = false,
		email = '',
		emailError = '',
		emailEl,
		password = '',
		passwordError = '',
		passwordEl,
		code = ''

	onMount(() => {

	})

	async function signUp(e) {
		e.preventDefault()
		const { user, error } = await authStoreSignUp({ email, password})
	}

	function keydown(e) {
		if(e.keyCode === 13) {
			signUp(e)
		}
	}

</script>

<div class="spacer"></div>

<section class="container">

	<h2>
		Sign Up
	</h2>

	{#if isInvitation}
		<p>
			You got an invitation
		</p>
	{/if}

	<form on:submit={e => signUp(e)}>

		<div class="form-item">
			<input type="email" bind:value={email} class="input" on:keydown={e => keydown(e)}>
			<!--<UiInput
				label="{$i18n.EMAIL}"
				type="email"
				bind:this={emailEl}
				bind:value={email}
				disabled={isInvitation}
				bind:error={emailError} />-->
		</div>
		<div class="form-item">
			<input type="password" bind:value={password} class="input" on:keydown={e => keydown(e)}>
			<!--<UiInput
				label="{$i18n.PASSWORD}"
				type="password"
				bind:this={passwordEl}
				bind:value={password}
				bind:error={passwordError} />-->
		</div>
		
		<button on:click={e => signUp(e)}>
			Sign Up
		</button>

		{#if !isInvitation}
			<span>
				or
				<a href="/sign-in/">
					go to sign in page
				</a>
			</span>
		{/if}
	</form>

</section>

<div class="spacer"></div>

<style>
	.container {
		position: relative;
		max-width:540px;
		margin:0 auto;
		border:var(--c-grey) 0px solid;
		border-radius: 6px;
		background:#FFF;
		padding:0 30px 30px 30px;
		box-shadow:var(--shadow-box);
	}

	.spacer {
		height:60px;
	}

	h2 {
		padding:24px 0;
		font-size: 3rem;
	}

	span {
		display:inline-block;
		padding:0 0 0 12px;
		font-size: 2rem;
	}

	.form-item {
		margin:0 0 24px 0;
	}

	p {
		margin:0 0 24px 0;
	}

	input {
		font-size: 2rem;
	}

	button {
		font-size: 2rem;
	}

</style>